import axios from "axios";
import React from "react";

export const GetMetadata = async () => {
    let res = await axios.get(`${Server}/api/metadata`);

    if (res.status === 200 && res.data && res.data.length > 0) {
        return res.data[0];
    } else {
        alert(JSON.stringify(res));
    }

    return { maintenanceMode: true };
};

export interface Metadata {
    id: string;
    maintenanceMode: boolean;
    maintenanceMessage: string;
    eventName: string;
    eventLogo: string;
    currentEventId?: string;
    color: string;
}

export const MetadataContext = React.createContext({} as Metadata);
